// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://43.230.203.249:89/',
  apiUrl: 'https://gstatcrm.xstreamapps.in/',
  recaptchaMinimumScore: 0.5,
  // recaptchaSiteKey: '6LeUJ9gsAAAAAHlCgBKquGiT-5xp3cHqPLDU-bHa', // local test
  recaptchaSiteKey: '6LfSptssAAAAAGmO0wJBnxeGyEeHM4Bgzr7a-3Mj', // production
  allowFileExtension: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
  allowExtesions: ['pdf', 'doc', 'docx'],
  maximumFileSize: 104857600,
  base64Key: 'wXYBgjl/7mBsFkHyjqkkGcXDr+9Ty2wlbgW8RTZT8wI=',
  encryptSecretKey: 'TBrwG3+lm1Eq6l8E0JzvKH+G5Y/fIkU6KjRBi5Hk9eE=',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
